import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {ORGANISER_DASHBOARD} from "src/app/app-routing.module";
import {AdministratorsService} from "@services";
import {UserDetail} from "@model";

export const UserResolver: ResolveFn<Observable<UserDetail> | UserDetail> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   adminService: AdministratorsService = inject(AdministratorsService),
   router: Router = inject(Router)): Observable<UserDetail> | UserDetail => {
    let userId = route.queryParams["userId"];
    if (!userId) {
      return of(userId);
    } else {
      return adminService.fetchUser(+userId, true)
        .pipe(
          take(1),
          mergeMap((res: UserDetail | null) => {
            if (res) {
              return of(res);
            } else {
              router.navigate([ORGANISER_DASHBOARD]);
              return EMPTY;
            }
          })
        );
    }
  }
